import { render, staticRenderFns } from "./AcompanhamentoAnexosList.vue?vue&type=template&id=7234d266"
import script from "./AcompanhamentoAnexosList.vue?vue&type=script&lang=js"
export * from "./AcompanhamentoAnexosList.vue?vue&type=script&lang=js"
import style0 from "./AcompanhamentoAnexosList.vue?vue&type=style&index=0&id=7234d266&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports